module.exports = __webpack_public_path__ + "static/img/v73.ce9fca3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/v73.png
// module id = xBCM
// module chunks = 1